import { initializeApp } from "firebase/app";
//import { getFirestore } from "firebase/firestore";
import { addDoc, collection } from "firebase/firestore";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signOut,
} from "firebase/auth";



const firebaseConfig = {
  apiKey: "AIzaSyAoURsH4qcfWnS1sxlQcm_DEFxZX2X_H34",
  authDomain: "fingen-dev.firebaseapp.com",
  projectId: "fingen-dev",
  storageBucket: "fingen-dev.appspot.com",
  messagingSenderId: "178232787951",
  appId: "1:178232787951:web:de86a2fb63134feca62c1a",
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
//const db = getFirestore(app);

const googleProvider = new GoogleAuthProvider();
const signInWithGoogle = async () => {
  const res = await signInWithPopup(auth, googleProvider)
    .then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential.accessToken;
      // The signed-in user info.
      const user = result.user;
      // ...
    })
    .catch((error) => {
      // Handle Errors here.
      const errorCode = error.code;
    });
  // const user = res.user;
  // try {
  //   const docRef = await addDoc(collection(db, "users"), {
  //     username: user.displayName,
  //     photoURL: user.photoURL,
  //   });

  //   console.log("Document written with ID: ", docRef.id);
  // } catch (e) {
  //   console.error("Error adding document: ", e);
  // }
};

const logout = () => {

  signOut(auth);
  
};

export { auth, signInWithGoogle, logout };
